// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs-carousel":"Breadcrumbs_breadcrumbs-carousel__7VoWU"};